import { ComponentProps } from 'react';
import { RenderCellProps } from '@bst/react-data-grid';
import { Checkbox } from '@bst/react-ui';

import { UserDTO } from '../../../apiclients/bstinsights';

type Props = {
  handleCheckedChange: (isChecked: boolean) => void;
  disabled?: boolean
} & RenderCellProps<UserDTO, unknown> & ComponentProps<typeof Checkbox>;

export const CheckboxCell = ({
  handleCheckedChange,
  disabled,
  ...props
}: Props) => {

  return (
    <Checkbox
      style={{
        height: "100%",
        width: "100%",
        display: "flex",
        justifyContent: "center",
      }}
      disabled={disabled}
      data-testid={`role-checkbox-${props.column.key}`}
      checked={props.checked}
      onCheckedChange={handleCheckedChange}
    />
  );
}